import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './shared/components/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { AuthGuard } from './shared/services/auth/auth.guard';

export const rootRouterConfig: Routes = [
  { 
    path: '', 
    redirectTo: 'dashboard', 
    pathMatch: 'full' 
  },
  {
    path: '', 
    component: AuthLayoutComponent,
    children: [
      { 
        path: 'sessions', 
        loadChildren: './views/sessions/sessions.module#SessionsModule',
        data: { title: 'Session'} 
      }
    ]
  },
  {
    path: '', 
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard', 
        loadChildren: './views/others/others.module#OthersModule', 
        data: { title: 'หน้าหลัก', breadcrumb: 'หน้าหลัก'}
      },
      {
        path: 'addbookingdata', 
        loadChildren: './views/add-booking-data/add-booking-data.module#AddBookingDataModule', 
        data: { title: 'เพิ่มข้อมูลการขอใช้รถ', breadcrumb: 'ข้อมูลการขอใช้รถ'}
      },
      {
        path: 'reportbookingdata', 
        loadChildren: './views/report-booking-data/report-booking-data.module#ReportBookingDataModule', 
        data: { title: 'รายงานข้อมูลการขอใช้รถ', breadcrumb: 'รายงานข้อมูลการขอใช้รถ'}
      },
      {
        path: 'cardriverdata', 
        loadChildren: './views/car-driver-data/car-driver-data.module#CarDriverDataModule', 
        data: { title: 'ข้อมูลรถยนต์และคนขับ', breadcrumb: 'ข้อมูลรถยนต์และคนขับ'}
      },
      {
        path: 'bookingapprove', 
        loadChildren: './views/booking-approve/booking-approve.module#BookingApproveModule', 
        data: { title: 'อนุมัติการขอใช้รถ', breadcrumb: 'ข้อมูลอนุมัติการขอใช้รถ'}
      },
      {
        path: 'bookingapprove2', 
        loadChildren: './views/booking-approve2/booking-approve.module#BookingApproveModule', 
        data: { title: 'อนุมัติการขอใช้รถ', breadcrumb: 'ข้อมูลอนุมัติการขอใช้รถ'}
      },
      {
        path: 'reportbooking', 
        loadChildren: './views/report-booking/report-booking.module#ReportBookingModule', 
        data: { title: 'รายงานข้อมูลการให้บริการ', breadcrumb: 'รายงานข้อมูลการให้บริการ'}
      }
      
    ],
  },
  { 
    path: '**', 
    redirectTo: 'sessions/404'
  }
];




// WEBPACK FOOTER //
// D:/Programing/carbooking/src/app/app.routing.ts